import { numberRequiredSchema, select2RequiredSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const assignChecklistSchema = object().shape({
    caseload_therapist_id: select2RequiredSchema,
    action: stringRequiredSchema,
    status: select2RequiredSchema,
    deadline: stringRequiredSchema,
    send_notification: stringRequiredSchema
});

export default assignChecklistSchema;